import React from 'react'
import PropTypes from 'prop-types'
import App from 'next/app'
import * as Sentry from '@sentry/browser'
import Router, { withRouter } from 'next/router'

// import '../polyfills'

import isServer from '../utils/isServer'
import getGlobals from '../utils/getGlobals'
import { trackPageView } from '../utils/analytics'

Router.events.on('routeChangeComplete', url => {
  setTimeout(() => {
    trackPageView(url)
  }, 0)
})

class IframeWidget extends App {
  static async getInitialProps({ Component, ctx }) {
    let pageProps = {}
    if (Component.getInitialProps) {
      pageProps = await Component.getInitialProps(ctx)
    }

    let statusCode = null
    if (pageProps && pageProps.statusCode) {
      statusCode = pageProps.statusCode

      if (ctx.res) {
        ctx.res.statusCode = statusCode
      }
    }

    return { pageProps, statusCode }
  }

  componentDidMount() {
    const {
      router: { asPath },
    } = this.props
    trackPageView(asPath)
  }

  constructor(props) {
    super(props)
    this.state = { error: null }

    if (!isServer() && getGlobals().IS_PRODUCTION) {
      const URL = getGlobals().SENTRY_URL

      if (URL) {
        Sentry.init({
          dsn: URL,
          whitelistUrls: [/d1b6poc6522jpx\.cloudfront\.net/],
        })
      }
    }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error })
    Sentry.withScope(scope => {
      Object.keys(errorInfo).forEach(key => {
        scope.setExtra(key, errorInfo[key])
      })
      Sentry.captureException(error)
    })
  }

  render() {
    const { Component, pageProps } = this.props
    if (this.state.error) {
      return <div>Error happened</div>
    }
    // <React.StrictMode>
    return <Component {...pageProps} />
  }
}

IframeWidget.propTypes = {
  router: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
}

export default withRouter(IframeWidget)
